export default function ArmyEquipmentRowRemove(rowAt) {
  return { type: 'Army_Equipment_Row_Rem', payload: rowAt };
}
